import { useState } from 'react';

import ShippingProfile from '@/shared/types/shipping/shippingProfile.type';
import ShippingProvider from '@/shared/types/shipping/shippingProvider.type';

type Args = {
  shippingProfile: ShippingProfile;
  shippingProviders: ShippingProvider[];
};

const useShippingProfileDetailsPanel = ({
  shippingProfile,
  shippingProviders,
}: Args) => {
  const [profileDetailsForm, setProfileDetailsForm] = useState({
    display_name: shippingProfile.display_name || '',
    shipping_provider_id: shippingProfile.shipping_provider_id || '',
    shipping_provider_key: shippingProfile.shipping_provider_key || '',
    shipping_method_id: shippingProfile.shipping_method_id || '',
    category: shippingProfile.category || '',
  });

  const [packagingPropertiesForm, setPackagingPropertiesForm] = useState(
    shippingProfile.packaging_properties,
  );

  const [formErrors, setFormErrors] = useState<
    Partial<typeof profileDetailsForm>
  >({});

  const onValidate = () => {
    const errors: Partial<Partial<typeof profileDetailsForm>> = {};

    if (!profileDetailsForm.display_name) {
      errors.display_name = 'Display Name is required';
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const getShippingProviderKey = (providerId: string) => {
    const providerById = shippingProviders.find(
      (item) => item.shipping_provider_id === providerId,
    );

    return providerById?.shipping_provider_key || '';
  };

  return {
    profileDetailsForm,
    packagingPropertiesForm,
    formErrors,
    setProfileDetailsForm,
    setPackagingPropertiesForm,
    onValidate,
    getShippingProviderKey,
  };
};

export default useShippingProfileDetailsPanel;
